const translations = {
  en: {
    // Navbar
    nav_home: 'Home',
    nav_fleet: 'Fleet',
    nav_contact: 'Contact',
    nav_admin: 'Admin',

    // Hero
    hero_badge: 'Trusted Car Rental in Tirana, Albania',
    hero_title_1: 'DRIVE ALBANIA',
    hero_title_2: 'WITH',
    hero_title_3: 'CONFIDENCE.',
    hero_desc: 'Explore Albania with comfort and confidence. Pick up your car in Tirana or directly at the airport. Transparent pricing, no hidden fees, and instant booking confirmation.',
    hero_cta_contact: 'Contact Us',
    hero_cta_cars: 'View All Cars',
    hero_stat_vehicles: 'Vehicles',
    hero_stat_trips: 'Trips Done',
    hero_stat_rating: 'Rating',
    hero_featured_badge: 'Featured Car',
    hero_featured_available: 'Available',
    hero_featured_year: '2026 · Hatchback · Automatic',
    hero_featured_per_day: 'per day',
    hero_featured_seats: 'Seats',
    hero_featured_trans: 'Trans.',
    hero_featured_fuel: 'Fuel',
    hero_featured_book: 'Book This Car',

    // Booking Engine
    booking_title: 'Reserve a Car',
    booking_pickup_loc: 'Pickup Location',
    booking_dropoff_loc: 'Drop-off Location',
    booking_pickup_date: 'Pickup Date',
    booking_return_date: 'Return Date',
    booking_search: 'Search Available Cars',
    booking_search_short: 'Search',
    booking_error: 'Please select both pickup and return dates.',
    booking_error_dates: 'Return date must be after pickup date.',
    booking_pill_center: 'Tirana City Center',
    booking_pill_airport: 'TIA Airport Pickup',
    booking_pill_cancel: 'Free cancellation',
    booking_pill_fees: 'No hidden fees',

    // Locations
    loc_tirana_center: 'Tirana City Center',
    loc_tirana_airport: "Tirana Int'l Airport (TIA)",

    // About
    about_badge: 'About Rent355',
    about_title_1: "TIRANA'S MOST",
    about_title_2: 'TRUSTED',
    about_title_3: 'RENTAL',
    about_years_badge: 'Years of Service',
    about_airport_badge: 'Airport',
    about_p1: 'For over <strong>14 years</strong>, Rent355 has been Albania\'s premier car rental service — rooted in Tirana, trusted by thousands of travelers from around the world.',
    about_p2: 'Whether you arrive at <strong>Tirana International Airport</strong> or need a vehicle in the city center, our team is there — ready to welcome you with a smile and the keys to your perfect car.',
    about_languages_label: 'We Speak Your Language',
    about_stat_years: 'Years Experience',
    about_stat_vehicles: 'Vehicles',
    about_stat_clients: 'Happy Clients',
    about_stat_rating: 'Rating',

    // Why Choose Us
    why_badge: 'Why Rent355',
    why_title_1: 'WHY CHOOSE',
    why_title_2: 'US',
    why_subtitle: 'Over 14 years of trusted service in Albania — here\'s what sets us apart.',
    why_1_title: 'Fully Insured',
    why_1_desc: 'Every vehicle comes with comprehensive insurance — drive with total confidence.',
    why_2_title: 'Multilingual Team',
    why_2_desc: 'Our staff speaks English, Italian, German and French — every guest feels at home.',
    why_3_title: 'Airport Pickup',
    why_3_desc: "Land at Tirana Airport and we'll be waiting — keys in hand, no delays.",
    why_4_title: '24/7 Support',
    why_4_desc: 'Always reachable by phone or WhatsApp — we never leave you stranded.',
    why_5_title: 'Best Price Guarantee',
    why_5_desc: 'Transparent pricing, no hidden fees. Starting from just €20/day.',
    why_6_title: '14+ Years Experience',
    why_6_desc: 'Since 2010, thousands of locals and tourists have trusted Rent355.',

    // Fleet
    fleet_title_1: 'FEATURED',
    fleet_title_2: 'FLEET',
    fleet_view_all: 'View All →',

    // Reviews
    reviews_badge: 'Client Reviews',
    reviews_title_1: 'WHAT OUR',
    reviews_title_2: 'CLIENTS SAY',
    reviews_google: 'Google Reviews',
    reviews_time_suffix: '· Google Review',

    // CTA
    cta_title_1: 'READY TO',
    cta_title_2: 'ROLL?',
    cta_desc: 'Join thousands of satisfied customers who trust Rent355 for their Albanian adventure.',
    cta_button: 'Book Your Car Today',
  },

  sq: {
    // Navbar
    nav_home: 'Kryefaqja',
    nav_fleet: 'Flotë',
    nav_contact: 'Kontakt',
    nav_admin: 'Admin',

    // Hero
    hero_badge: 'Rent355 — Qira Makinash e Besuar në Tiranë',
    hero_title_1: 'DREJTONI SHQIPËRINË',
    hero_title_2: 'ME',
    hero_title_3: 'BESIM.',
    hero_desc: 'Eksploroni Shqipërinë me rehati dhe besim. Merrni makinën tuaj në Tiranë ose direkt në aeroport. Çmime transparente, pa tarifa të fshehura, dhe konfirmim i menjëhershëm rezervimi.',
    hero_cta_contact: 'Na Kontaktoni',
    hero_cta_cars: 'Shiko të Gjitha Makinat',
    hero_stat_vehicles: 'Automjete',
    hero_stat_trips: 'Udhëtime',
    hero_stat_rating: 'Vlerësim',
    hero_featured_badge: 'Makina e Zgjedhur',
    hero_featured_available: 'E Disponueshme',
    hero_featured_year: '2026 · Hatchback · Automatike',
    hero_featured_per_day: 'në ditë',
    hero_featured_seats: 'Ulëse',
    hero_featured_trans: 'Trans.',
    hero_featured_fuel: 'Karburanti',
    hero_featured_book: 'Rezervo Këtë Makinë',

    // Booking Engine
    booking_title: 'Rezervo një Makinë',
    booking_pickup_loc: 'Vendi i Marrjes',
    booking_dropoff_loc: 'Vendi i Kthimit',
    booking_pickup_date: 'Data e Marrjes',
    booking_return_date: 'Data e Kthimit',
    booking_search: 'Kërko Makinat e Disponueshme',
    booking_search_short: 'Kërko',
    booking_error: 'Ju lutemi zgjidhni të dyja datat.',
    booking_error_dates: 'Data e kthimit duhet të jetë pas datës së marrjes.',
    booking_pill_center: 'Qendra e Tiranës',
    booking_pill_airport: 'Marrje në Aeroport TIA',
    booking_pill_cancel: 'Anulim falas',
    booking_pill_fees: 'Pa tarifa të fshehura',

    // Locations
    loc_tirana_center: 'Qendra e Tiranës',
    loc_tirana_airport: 'Aeroporti Ndërkombëtar i Tiranës (TIA)',

    // About
    about_badge: 'Rreth Rent355',
    about_title_1: 'QIRA MAKINASH MË E',
    about_title_2: 'BESUAR',
    about_title_3: 'NË TIRANË',
    about_years_badge: 'Vjet Shërbimi',
    about_airport_badge: 'Aeroport',
    about_p1: 'Për më shumë se <strong>14 vjet</strong>, Rent355 ka qenë shërbimi kryesor i qirasë së makinave në Shqipëri — i rrënjosur në Tiranë, i besuar nga mijëra udhëtarë nga e gjithë bota.',
    about_p2: 'Nëse mbërrini në <strong>Aeroportin Ndërkombëtar të Tiranës</strong> ose keni nevojë për një automjet në qendër të qytetit, ekipi ynë është atje — gati t\'ju mirëpresë me një buzëqeshje dhe çelësat e makinës suaj të përsosur.',
    about_languages_label: 'Flasim Gjuhën Tuaj',
    about_stat_years: 'Vjet Eksperiencë',
    about_stat_vehicles: 'Automjete',
    about_stat_clients: 'Klientë të Kënaqur',
    about_stat_rating: 'Vlerësim',

    // Why Choose Us
    why_badge: 'Pse Rent355',
    why_title_1: 'PSE TË ZGJIDHNI',
    why_title_2: 'NE',
    why_subtitle: 'Mbi 14 vjet shërbim të besuar në Shqipëri — ja çfarë na dallon.',
    why_1_title: 'Plotësisht i Siguruar',
    why_1_desc: 'Çdo automjet vjen me sigurim gjithëpërfshirës — drejtoni me besim të plotë.',
    why_2_title: 'Ekip Shumëgjuhësh',
    why_2_desc: 'Stafi ynë flet anglisht, italisht, gjermanisht dhe frëngjisht — çdo mysafir ndihet si në shtëpi.',
    why_3_title: 'Marrje në Aeroport',
    why_3_desc: 'Zbritni në Aeroportin e Tiranës dhe ne do të jemi atje — çelësat gati, pa vonesa.',
    why_4_title: 'Mbështetje 24/7',
    why_4_desc: 'Gjithmonë të arritshëm me telefon ose WhatsApp — nuk ju lëmë kurrë pa ndihmë.',
    why_5_title: 'Garanci e Çmimit më të Mirë',
    why_5_desc: 'Çmime transparente, pa tarifa të fshehura. Duke filluar nga vetëm €20/ditë.',
    why_6_title: 'Mbi 14 Vjet Eksperiencë',
    why_6_desc: 'Që nga viti 2010, mijëra vendas dhe turistë i kanë besuar Rent355.',

    // Fleet
    fleet_title_1: 'FLOTË E',
    fleet_title_2: 'ZGJEDHUR',
    fleet_view_all: 'Shiko të Gjitha →',

    // Reviews
    reviews_badge: 'Vlerësimet e Klientëve',
    reviews_title_1: 'ÇKA THONË',
    reviews_title_2: 'KLIENTËT TANË',
    reviews_google: 'Vlerësimet në Google',
    reviews_time_suffix: '· Vlerësim në Google',

    // CTA
    cta_title_1: 'GATI TË',
    cta_title_2: 'NISENI?',
    cta_desc: 'Bashkohuni me mijëra klientë të kënaqur që i besojnë Rent355 aventurën e tyre shqiptare.',
    cta_button: 'Rezervo Makinën Tuaj Sot',
  },

  fr: {
    // Navbar
    nav_home: 'Accueil',
    nav_fleet: 'Flotte',
    nav_contact: 'Contact',
    nav_admin: 'Admin',

    // Hero
    hero_badge: 'Location de voiture de confiance à Tirana, Albanie',
    hero_title_1: 'CONDUISEZ L\'ALBANIE',
    hero_title_2: 'AVEC',
    hero_title_3: 'CONFIANCE.',
    hero_desc: 'Explorez l\'Albanie avec confort et confiance. Récupérez votre voiture à Tirana ou directement à l\'aéroport. Prix transparents, sans frais cachés, et confirmation de réservation instantanée.',
    hero_cta_contact: 'Nous Contacter',
    hero_cta_cars: 'Voir Toutes les Voitures',
    hero_stat_vehicles: 'Véhicules',
    hero_stat_trips: 'Trajets Effectués',
    hero_stat_rating: 'Note',
    hero_featured_badge: 'Voiture en Vedette',
    hero_featured_available: 'Disponible',
    hero_featured_year: '2026 · Hatchback · Automatique',
    hero_featured_per_day: 'par jour',
    hero_featured_seats: 'Places',
    hero_featured_trans: 'Trans.',
    hero_featured_fuel: 'Carburant',
    hero_featured_book: 'Réserver Cette Voiture',

    // Booking Engine
    booking_title: 'Réserver une Voiture',
    booking_pickup_loc: 'Lieu de Prise en Charge',
    booking_dropoff_loc: 'Lieu de Retour',
    booking_pickup_date: 'Date de Prise en Charge',
    booking_return_date: 'Date de Retour',
    booking_search: 'Rechercher les Voitures Disponibles',
    booking_search_short: 'Rechercher',
    booking_error: 'Veuillez sélectionner les deux dates.',
    booking_error_dates: 'La date de retour doit être après la date de prise en charge.',
    booking_pill_center: 'Centre-ville de Tirana',
    booking_pill_airport: 'Prise en charge à l\'aéroport TIA',
    booking_pill_cancel: 'Annulation gratuite',
    booking_pill_fees: 'Sans frais cachés',

    // Locations
    loc_tirana_center: 'Centre-ville de Tirana',
    loc_tirana_airport: 'Aéroport International de Tirana (TIA)',

    // About
    about_badge: 'À Propos de Rent355',
    about_title_1: 'LA LOCATION LA PLUS',
    about_title_2: 'FIABLE',
    about_title_3: 'DE TIRANA',
    about_years_badge: 'Ans de Service',
    about_airport_badge: 'Aéroport',
    about_p1: 'Depuis plus de <strong>14 ans</strong>, Rent355 est le premier service de location de voitures en Albanie — ancré à Tirana, reconnu par des milliers de voyageurs du monde entier.',
    about_p2: 'Que vous arriviez à <strong>l\'Aéroport International de Tirana</strong> ou que vous ayez besoin d\'un véhicule en centre-ville, notre équipe est là — prête à vous accueillir avec le sourire et les clés de votre voiture idéale.',
    about_languages_label: 'Nous Parlons Votre Langue',
    about_stat_years: 'Ans d\'Expérience',
    about_stat_vehicles: 'Véhicules',
    about_stat_clients: 'Clients Satisfaits',
    about_stat_rating: 'Note',

    // Why Choose Us
    why_badge: 'Pourquoi Rent355',
    why_title_1: 'POURQUOI NOUS',
    why_title_2: 'CHOISIR',
    why_subtitle: 'Plus de 14 ans de service de confiance en Albanie — voici ce qui nous distingue.',
    why_1_title: 'Entièrement Assuré',
    why_1_desc: 'Chaque véhicule est couvert par une assurance complète — conduisez en toute confiance.',
    why_2_title: 'Équipe Multilingue',
    why_2_desc: 'Notre personnel parle anglais, italien, allemand et français — chaque client se sent chez soi.',
    why_3_title: 'Prise en Charge à l\'Aéroport',
    why_3_desc: "Atterrissez à l'aéroport de Tirana et nous serons là — clés en main, sans délai.",
    why_4_title: 'Assistance 24h/24 et 7j/7',
    why_4_desc: 'Toujours joignable par téléphone ou WhatsApp — nous ne vous laissons jamais en plan.',
    why_5_title: 'Garantie Meilleur Prix',
    why_5_desc: 'Prix transparents, sans frais cachés. À partir de seulement €20/jour.',
    why_6_title: 'Plus de 14 Ans d\'Expérience',
    why_6_desc: 'Depuis 2010, des milliers de locaux et de touristes font confiance à Rent355.',

    // Fleet
    fleet_title_1: 'FLOTTE',
    fleet_title_2: 'EN VEDETTE',
    fleet_view_all: 'Voir Tout →',

    // Reviews
    reviews_badge: 'Avis Clients',
    reviews_title_1: 'CE QUE DISENT',
    reviews_title_2: 'NOS CLIENTS',
    reviews_google: 'Avis Google',
    reviews_time_suffix: '· Avis Google',

    // CTA
    cta_title_1: 'PRÊT À',
    cta_title_2: 'PARTIR?',
    cta_desc: 'Rejoignez des milliers de clients satisfaits qui font confiance à Rent355 pour leur aventure albanaise.',
    cta_button: 'Réservez Votre Voiture Aujourd\'hui',
  },

  de: {
    // Navbar
    nav_home: 'Startseite',
    nav_fleet: 'Flotte',
    nav_contact: 'Kontakt',
    nav_admin: 'Admin',

    // Hero
    hero_badge: 'Vertrauensvoller Mietwagen in Tirana, Albanien',
    hero_title_1: 'ALBANIEN ERLEBEN',
    hero_title_2: 'MIT',
    hero_title_3: 'VERTRAUEN.',
    hero_desc: 'Entdecken Sie Albanien mit Komfort und Sicherheit. Holen Sie Ihr Auto in Tirana oder direkt am Flughafen ab. Transparente Preise, keine versteckten Gebühren und sofortige Buchungsbestätigung.',
    hero_cta_contact: 'Kontakt aufnehmen',
    hero_cta_cars: 'Alle Autos ansehen',
    hero_stat_vehicles: 'Fahrzeuge',
    hero_stat_trips: 'Fahrten',
    hero_stat_rating: 'Bewertung',
    hero_featured_badge: 'Empfohlenes Fahrzeug',
    hero_featured_available: 'Verfügbar',
    hero_featured_year: '2026 · Fließheck · Automatik',
    hero_featured_per_day: 'pro Tag',
    hero_featured_seats: 'Sitze',
    hero_featured_trans: 'Getriebe',
    hero_featured_fuel: 'Kraftstoff',
    hero_featured_book: 'Dieses Auto buchen',

    // Booking Engine
    booking_title: 'Auto reservieren',
    booking_pickup_loc: 'Abholort',
    booking_dropoff_loc: 'Rückgabeort',
    booking_pickup_date: 'Abholdatum',
    booking_return_date: 'Rückgabedatum',
    booking_search: 'Verfügbare Autos suchen',
    booking_search_short: 'Suchen',
    booking_error: 'Bitte wählen Sie beide Daten aus.',
    booking_error_dates: 'Das Rückgabedatum muss nach dem Abholdatum liegen.',
    booking_pill_center: 'Tirana Stadtzentrum',
    booking_pill_airport: 'Flughafenabholung TIA',
    booking_pill_cancel: 'Kostenlose Stornierung',
    booking_pill_fees: 'Keine versteckten Gebühren',

    // Locations
    loc_tirana_center: 'Tirana Stadtzentrum',
    loc_tirana_airport: 'Internationaler Flughafen Tirana (TIA)',

    // About
    about_badge: 'Über Rent355',
    about_title_1: 'TIRANAS',
    about_title_2: 'VERTRAUENSWÜRDIGSTE',
    about_title_3: 'VERMIETUNG',
    about_years_badge: 'Jahre Erfahrung',
    about_airport_badge: 'Flughafen',
    about_p1: 'Seit über <strong>14 Jahren</strong> ist Rent355 Albaniens führender Mietwagenservice — verwurzelt in Tirana, vertraut von Tausenden von Reisenden aus aller Welt.',
    about_p2: 'Ob Sie am <strong>Internationalen Flughafen Tirana</strong> ankommen oder ein Fahrzeug im Stadtzentrum benötigen, unser Team ist für Sie da — bereit, Sie mit einem Lächeln und den Schlüsseln zu Ihrem perfekten Auto zu empfangen.',
    about_languages_label: 'Wir sprechen Ihre Sprache',
    about_stat_years: 'Jahre Erfahrung',
    about_stat_vehicles: 'Fahrzeuge',
    about_stat_clients: 'Zufriedene Kunden',
    about_stat_rating: 'Bewertung',

    // Why Choose Us
    why_badge: 'Warum Rent355',
    why_title_1: 'WARUM',
    why_title_2: 'UNS WÄHLEN',
    why_subtitle: 'Über 14 Jahre vertrauensvoller Service in Albanien — das macht uns besonders.',
    why_1_title: 'Vollständig Versichert',
    why_1_desc: 'Jedes Fahrzeug kommt mit einer Vollkaskoversicherung — fahren Sie mit vollem Vertrauen.',
    why_2_title: 'Mehrsprachiges Team',
    why_2_desc: 'Unser Personal spricht Englisch, Italienisch, Deutsch und Französisch — jeder Gast fühlt sich wie zu Hause.',
    why_3_title: 'Flughafenabholung',
    why_3_desc: 'Landen Sie am Flughafen Tirana und wir warten auf Sie — Schlüssel in der Hand, ohne Verzögerung.',
    why_4_title: '24/7 Support',
    why_4_desc: 'Immer per Telefon oder WhatsApp erreichbar — wir lassen Sie nie im Stich.',
    why_5_title: 'Bestpreisgarantie',
    why_5_desc: 'Transparente Preise, keine versteckten Gebühren. Ab nur €20/Tag.',
    why_6_title: 'Über 14 Jahre Erfahrung',
    why_6_desc: 'Seit 2010 vertrauen Tausende von Einheimischen und Touristen auf Rent355.',

    // Fleet
    fleet_title_1: 'AUSGEWÄHLTE',
    fleet_title_2: 'FLOTTE',
    fleet_view_all: 'Alle ansehen →',

    // Reviews
    reviews_badge: 'Kundenbewertungen',
    reviews_title_1: 'WAS UNSERE',
    reviews_title_2: 'KUNDEN SAGEN',
    reviews_google: 'Google-Bewertungen',
    reviews_time_suffix: '· Google-Bewertung',

    // CTA
    cta_title_1: 'BEREIT',
    cta_title_2: 'LOSZUFAHREN?',
    cta_desc: 'Schließen Sie sich Tausenden zufriedener Kunden an, die Rent355 für ihr Albanien-Abenteuer vertrauen.',
    cta_button: 'Buchen Sie Ihr Auto Heute',
  },

  nl: {
    // Navbar
    nav_home: 'Startpagina',
    nav_fleet: 'Vloot',
    nav_contact: 'Contact',
    nav_admin: 'Admin',

    // Hero
    hero_badge: 'Betrouwbare autoverhuur in Tirana, Albanië',
    hero_title_1: 'ONTDEK ALBANIË',
    hero_title_2: 'MET',
    hero_title_3: 'VERTROUWEN.',
    hero_desc: 'Verken Albanië met comfort en vertrouwen. Haal uw auto op in Tirana of rechtstreeks op het vliegveld. Transparante prijzen, geen verborgen kosten en directe boekingsbevestiging.',
    hero_cta_contact: 'Neem Contact Op',
    hero_cta_cars: 'Bekijk Alle Auto\'s',
    hero_stat_vehicles: 'Voertuigen',
    hero_stat_trips: 'Ritten',
    hero_stat_rating: 'Beoordeling',
    hero_featured_badge: 'Uitgelichte Auto',
    hero_featured_available: 'Beschikbaar',
    hero_featured_year: '2026 · Hatchback · Automaat',
    hero_featured_per_day: 'per dag',
    hero_featured_seats: 'Zitplaatsen',
    hero_featured_trans: 'Trans.',
    hero_featured_fuel: 'Brandstof',
    hero_featured_book: 'Boek Deze Auto',

    // Booking Engine
    booking_title: 'Reserveer een Auto',
    booking_pickup_loc: 'Ophaallocatie',
    booking_dropoff_loc: 'Inleverlocatie',
    booking_pickup_date: 'Ophaaldatum',
    booking_return_date: 'Inleverdatum',
    booking_search: 'Zoek Beschikbare Auto\'s',
    booking_search_short: 'Zoeken',
    booking_error: 'Selecteer beide datums.',
    booking_error_dates: 'De inleverdatum moet na de ophaaldatum liggen.',
    booking_pill_center: 'Tirana Stadscentrum',
    booking_pill_airport: 'Luchthaven TIA Ophaal',
    booking_pill_cancel: 'Gratis annulering',
    booking_pill_fees: 'Geen verborgen kosten',

    // Locations
    loc_tirana_center: 'Tirana Stadscentrum',
    loc_tirana_airport: 'Internationale Luchthaven Tirana (TIA)',

    // About
    about_badge: 'Over Rent355',
    about_title_1: 'TIRANA\'S MEEST',
    about_title_2: 'VERTROUWDE',
    about_title_3: 'VERHUUR',
    about_years_badge: 'Jaar Service',
    about_airport_badge: 'Luchthaven',
    about_p1: 'Al meer dan <strong>14 jaar</strong> is Rent355 de toonaangevende autoverhuurservice van Albanië — geworteld in Tirana, vertrouwd door duizenden reizigers van over de hele wereld.',
    about_p2: 'Of u nu aankomt op de <strong>Internationale Luchthaven van Tirana</strong> of een voertuig nodig heeft in het stadscentrum, ons team staat voor u klaar — bereid om u te verwelkomen met een glimlach en de sleutels van uw perfecte auto.',
    about_languages_label: 'Wij Spreken Uw Taal',
    about_stat_years: 'Jaar Ervaring',
    about_stat_vehicles: 'Voertuigen',
    about_stat_clients: 'Tevreden Klanten',
    about_stat_rating: 'Beoordeling',

    // Why Choose Us
    why_badge: 'Waarom Rent355',
    why_title_1: 'WAAROM',
    why_title_2: 'ONS KIEZEN',
    why_subtitle: 'Meer dan 14 jaar betrouwbare service in Albanië — dit maakt ons uniek.',
    why_1_title: 'Volledig Verzekerd',
    why_1_desc: 'Elk voertuig wordt geleverd met een uitgebreide verzekering — rijd met volledig vertrouwen.',
    why_2_title: 'Meertalig Team',
    why_2_desc: 'Ons personeel spreekt Engels, Italiaans, Duits en Frans — elke gast voelt zich thuis.',
    why_3_title: 'Luchthaven Ophaal',
    why_3_desc: 'Land op de luchthaven van Tirana en wij staan klaar — sleutels in de hand, geen vertraging.',
    why_4_title: '24/7 Support',
    why_4_desc: 'Altijd bereikbaar via telefoon of WhatsApp — wij laten u nooit in de steek.',
    why_5_title: 'Beste Prijsgarantie',
    why_5_desc: 'Transparante prijzen, geen verborgen kosten. Vanaf slechts €20/dag.',
    why_6_title: 'Meer dan 14 Jaar Ervaring',
    why_6_desc: 'Sinds 2010 vertrouwen duizenden locals en toeristen op Rent355.',

    // Fleet
    fleet_title_1: 'UITGELICHTE',
    fleet_title_2: 'VLOOT',
    fleet_view_all: 'Bekijk Alles →',

    // Reviews
    reviews_badge: 'Klantbeoordelingen',
    reviews_title_1: 'WAT ONZE',
    reviews_title_2: 'KLANTEN ZEGGEN',
    reviews_google: 'Google Beoordelingen',
    reviews_time_suffix: '· Google Beoordeling',

    // CTA
    cta_title_1: 'KLAAR OM',
    cta_title_2: 'TE RIJDEN?',
    cta_desc: 'Sluit u aan bij duizenden tevreden klanten die Rent355 vertrouwen voor hun Albanees avontuur.',
    cta_button: 'Boek Uw Auto Vandaag',
  },
};

export default translations;
